import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import FormConfigQualifierAttributeForm from "./FormConfigQualifierAttributeForm";
import { IFormConfigQualifierAttribute } from "../../../service/formconfiguration/FormConfigQualifierAttribute";

export interface State {}

export interface CreateFormConfigQualifierAttributeFormProps
  extends FormComponentProps {
  translate: any;
  registerFormSubmitEventHandler?: any;
}

class CreateFormConfigQualifierAttributeForm extends React.Component<
  CreateFormConfigQualifierAttributeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;

    registerFormSubmitEventHandler((e) => {
      e.preventDefault();
      let newFormConfigQualifierAttributeData = {} as IFormConfigQualifierAttribute;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newFormConfigQualifierAttributeData.attribute = {
            ...newFormConfigQualifierAttributeData.attribute,
            ...values,
            valid: true
          };

          newFormConfigQualifierAttributeData = {
            ...newFormConfigQualifierAttributeData,
            ...values,
            attributeCode: values.code
          };
        }
      });

      return newFormConfigQualifierAttributeData;
    });
  }

  render() {
    const { translate } = this.props;

    const { getFieldDecorator, setFieldsValue } = this.props.form;

    return (
      <FormConfigQualifierAttributeForm
        translate={translate}
        getFieldDecorator={getFieldDecorator}
        setFieldsValue={setFieldsValue}
      ></FormConfigQualifierAttributeForm>
    );
  }
}

export default CreateFormConfigQualifierAttributeForm;
